import type { SVGProps } from 'react';
const DawnFlagTH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-TH_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-TH_svg__a)">
      <path fill="#F12532" d="M0 3.2h22V0H0zM0 16h22v-3.2H0z" />
      <path fill="#322B6C" d="M0 10.667h22V5.333H0z" />
    </g>
  </svg>
);
export default DawnFlagTH;
